var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudits = function SvgAudits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.083a1.667 1.667 0 0 1 .833 3.108v.642h.834c.92 0 1.666.747 1.666 1.667v.833h-6.666V17.5h-.001a1.7 1.7 0 0 1 .075-.495 1.666 1.666 0 0 1 1.59-1.172h.835v-.642a1.662 1.662 0 0 1-.834-1.441c0-.863.657-1.573 1.497-1.658zm1.666-1.22a3.333 3.333 0 0 0-4.9 3.693A3.33 3.33 0 0 0 9.999 17.5H3.332V5.833L6.666 2.5h10z"
  })));
};
export default SvgAudits;